import { Link } from "react-router-dom";
import { useI18n } from "../i18n";

export default function NotFound() {
  const { t } = useI18n();
  return (
    <div className="center-state">
      <div className="big-code" aria-hidden>404</div>
      <h1>{t("notFound.title")}</h1>
      <p className="muted">{t("notFound.text")}</p>
      <Link className="button primary" to="/">{t("notFound.home")}</Link>
    </div>
  );
}

export function ErrorPage({ error }: { error?: unknown }) {
  const { t } = useI18n();
  return (
    <div className="center-state">
      <div className="big-code" aria-hidden>!</div>
      <h1>{t("errorPage.title")}</h1>
      <p className="muted">{t("errorPage.text")}</p>
      {error instanceof Error && <code>{error.message}</code>}
      <button className="button" onClick={() => window.location.reload()}>{t("errorPage.reload")}</button>
    </div>
  );
}
